'use client';
/* Built In Imports */
// import NextLink from 'next/link';
import { Link } from '@chakra-ui/next-js';

import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';

/* External Imports */
import {
  Box,
  Button,
  Center,
  Flex,
  Image,
  Spinner,
  Switch,
  Text,
} from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
import filter from 'lodash/filter';
import { nanoid } from 'nanoid';
import { MdOutlineFileDownload } from 'react-icons/md';

/* Internal Imports */
/* Components */
import CalendarTabsCard from '@app-ps/Components/Card/CalendarTabsCard';
import LazyLoadImageComponent from '@app-ps/Components/Ui/LazyLoadImageComponent';
import { refineUrlDomain } from '@app-ps/Components/Utility/utils';
import StructuredTextParser from '@app-ps/Utility/StructuredTextParser';
import config from '@config';

/* Services */
import { fetchUpcomingListData } from '@Services/projSamskritiService';
import { usePathname, useSearchParams } from 'next/navigation';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';

/**
 * Renders the Production Vertical List component
 *
 * @param {object} sectionContent - Data for section
 * @param {string} region - Region of the section
 * @param {string} lang - Language of the section
 * @returns {ReactElement} Production Vertical List component
 */
const ProductionVerticalList = ({ sectionContent, region, lang }) => {
  // console.log(sectionContent, '');
  const path = usePathname();
  const searchParams = useSearchParams();
  const router = useRouter();
  const isScheduled = searchParams.get('scheduled');
  // console.log(isScheduled, 'scheduled');
  const [isLoading, setIsLoading] = useState(false);
  const [totalResults, setTotalResults] = useState(0);
  const [extractedObjects, setExtractedObjects] = useState([]);
  // const isMobile = useMediaQuery({ maxWidth: 767 });
  const [cardsSlice, setCardSlice] = useState(5);
  // console.log(extractedObjects, 'prodverticallist');
  const [masterObject, setMasterObject] = useState([]);
  const [showOnlyScheduled, setShowOnlyScheduled] = useState('');
  const [catType, setCatType] = useState('');
  const [startRec, setStartRec] = useState(0);
  const [message, setMessage] = useState('');
  const {
    showOnlyScheduledProductionsVisibility,
    ourRepertoireProductionTypeFiltersVisibility,
    productionTypeFilter,
    cardCtaLabel,
  } = sectionContent;
  // const query = {
  //   type: catType,
  //   scheduled: searchParams.get('scheduled') === '1' ? '1' : '',
  // };

  // console.log(sectionContent, "==> sectionContent")
  useEffect(() => {
    (async () => {
      let curCategory = null;
      setIsLoading(true);
      if (
        ourRepertoireProductionTypeFiltersVisibility &&
        productionTypeFilter
      ) {
        curCategory = filter(productionTypeFilter?.json, function (filter) {
          return filter.slug === searchParams.get('type');
        })[0];
      }
      let prgData =
        (await fetchUpcomingListData(
          curCategory?.id || '313',
          '',
          '',
          5,
          startRec
        )) || {};
      // console.log(prgData, 'prgdata');
      // let [results, resultcount] = prgData;
      if (!showOnlyScheduled) {
        let pastPerformances = sectionContent?.pastPerformances.map(
          ({ title, urlAlias, summary, category, heroSection, heroImage }) => ({
            title: title,
            urlAlias: urlAlias,
            type: 'past',
            heroSection: heroSection,
            heroImage: heroImage,
            // descriptive_text: summary,
            program_category: category,
          })
        );
        // console.log('pastPerformances', pastPerformances)
        if (catType) {
          pastPerformances = pastPerformances.filter(perf => {
            return (
              perf.program_category?.toLowerCase() === catType?.toLowerCase()
            );
          });
        }

        // console.log('pastPerformances22', pastPerformances)

        if (prgData && extractedObjects?.length === totalResults) {
          if (prgData.extracted) {
            prgData.extracted = prgData?.extracted?.concat(pastPerformances);
          } else {
            prgData.extracted = pastPerformances;
          }
        }
      }
      setTotalResults(() =>
        showOnlyScheduled
          ? prgData?.resultcount
          : prgData.resultcount
          ? prgData.resultcount + sectionContent?.pastPerformances?.length
          : extractedObjects.length
      );
      if (totalResults === 0) {
        setMessage(sectionContent?.scheduleEmptyMessage);
      } else {
        setMessage('');
      }

      if (prgData?.extracted && extractedObjects) {
        setExtractedObjects(
          () => new Set([...extractedObjects, ...prgData?.extracted])
        );
        setMasterObject(prgData?.extracted);
      }
    })();
    setIsLoading(false);
  }, [catType, startRec, showOnlyScheduled]);

  useEffect(() => {
    setStartRec(0);
  }, [catType]);

  useEffect(() => {
    // console.log('searchParams', searchParams, searchParams.get('type'));
    setCatType(searchParams.get('type')?.toLowerCase() || '');
    setShowOnlyScheduled(
      searchParams.get('scheduled') !== null
        ? searchParams.get('scheduled')
        : ''
    );
  }, [searchParams]);

  useEffect(() => {
    if (showOnlyScheduled) {
      const prgList = filter([...extractedObjects], function (prg) {
        return prg.type !== 'past';
      });
      setExtractedObjects(prgList);
    } else {
      setExtractedObjects(masterObject);
    }
  }, [showOnlyScheduled]);
  // console.log(extractedObjects, 'extro');

  // const [activeVideoId, setActiveVideoId] = useState(null);
  const [opts, setOpts] = useState({}); // Store video options

  useEffect(() => {
    setOpts({
      height: '100%', // Set height based on your box size
      width: '100%', // Full width of the container
      playerVars: {
        autoplay: 1, // Auto-play the video when it loads
      },
    });
  }, []);

  const handleChange = e => {
    e.preventDefault(); // Prevent default behavior.

    const basePath = path.split('?')[0]; // `usePathname` already gives the path without query parameters.
    const queryString = new URLSearchParams({
      type: searchParams.get('type') !== null ? searchParams.get('type') : '', // Keeps the current category type.
      scheduled: e.target.checked ? '1' : '', // Toggles the 'scheduled' query parameter.
    }).toString();

    // Construct the new URL with updated query parameters.
    const newUrl = `${basePath}?${queryString}`;

    // Use the `router.push` method from `next/navigation`.
    router.push(newUrl, { scroll: false });
  };

  // const download = async url => {
  //   downloadUrl(url, `media-kit-${new Date().getMilliseconds()}`);
  // };
  // console.log(extractedObjects, 'extractedObjects');
  return (
    <Box
      background="#010509"
      w="100%"
      pt={{ lg: '4rem', md: '4rem' }}
      pb={{ lg: '15rem', md: '4rem', base: '2rem' }}
    >
      <Box
        mx="auto"
        height={{ base: '1rem' }}
        display="flex"
        mt={{ '2xl': '5rem', lg: '5rem', base: '1rem', md: '3rem' }}
        mb={{ '2xl': '5rem', lg: '10rem', base: '1rem', md: '3rem' }}
        justifyContent="center"
        alignItems="center"
        flexDirection="row"
      >
        <LazyLoadImageComponent
          width={{ base: '29px', md: '91px' }}
          transform={{ base: 'rotate(270deg)' }}
          src={`${config.imgPath}/d/46272/1718963233-colam-flowers-origin.png`}
          alt="flower image"
        />
      </Box>

      {/* heading */}
      <Box
        color="#FEFAF6"
        display="flex"
        gap={{ base: '.5rem' }}
        letterSpacing={'0.16px'}
        marginBottom={{ lg: '2rem', md: '2rem', lg: '0', base: '1.5rem' }}
        fontSize={{ base: '1.5rem', md: '2.25rem' }}
        fontFamily="var(--FedraSerifDisplay)"
        alignItems="center"
        justifyContent="center"
        lineHeight={{ base: '1.8rem', lg: '2.7rem' }}
      >
        <Text fontWeight={400}>Our</Text>
        <Text fontWeight={700}>Repertoire</Text>
      </Box>

      {/* filter boxes container */}
      {ourRepertoireProductionTypeFiltersVisibility && productionTypeFilter && (
        <Flex
          justify={{ sm: 'center' }}
          gap={{ base: '1rem', lg: '1.5rem' }}
          sx={{
            '::-webkit-scrollbar': {
              height: '8px', // Adjust scrollbar height if needed
              backgroundColor: 'black', // Set scrollbar background color to black
            },
            '::-webkit-scrollbar-thumb': {
              backgroundColor: 'black', // Make scrollbar thumb blend with the background
            },
            '::-webkit-scrollbar-track': {
              backgroundColor: 'black', // Set the track to black
            },
          }}
          overflowX="auto"
          minWidth="100%"
          width="100%"
          mb={{ base: '1rem', lg: '0' }}
        >
          {productionTypeFilter?.json?.map((filter, index) => {
            return (
              <Link
                href={refineUrlDomain(
                  `/productions/list?type=${filter?.slug}&scheduled=${showOnlyScheduled}`,
                  region,
                  lang
                )}
                key={index}
                // passHref
                prefetch
                // legacyBehavior
                scroll={false}
                _hover={{ boxShadow: 'none' }}
                _focus={{ boxShadow: 'none' }}
              >
                <Box
                  key={index}
                  cursor="pointer"
                  width={{ base: '99px', md: '150px' }}
                  bg="black"
                  height="auto"
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  justifyContent="center"
                  textAlign="center"
                  marginTop={{ lg: '2rem' }}
                >
                  <Box
                    width={{ base: '99px', md: '150px' }}
                    height={{ base: '99px', md: '150px' }}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    overflow="hidden"
                    borderRadius="50%"
                    _hover={{
                      border: '5px solid #F18128',
                    }}
                    border={
                      catType === filter?.slug ? '5px solid #F18128' : 'none'
                    }
                  >
                    <Image src={filter.img} objectFit="cover" width="100%" />
                  </Box>
                  <Text
                    letterSpacing="2%"
                    lineHeight="1.8rem"
                    fontSize="1.125rem"
                    fontWeight={400}
                    textAlign="center"
                    textColor="#FEFAF6"
                    whiteSpace="nowrap"
                    fontFamily="var(--FedraSansStd-book)"
                    mt={2}
                  >
                    {filter.title}
                  </Text>
                </Box>
              </Link>
            );
          })}
        </Flex>
      )}

      {/* wrapper */}
      <Box
        marginTop={{ lg: '3rem' }}
        display="flex"
        flexDirection={{ base: 'column', xl: 'row' }}
        w="100%"
        mx="auto"
        background="#010509"
        maxW={{ xl: 1200, '2xl': '1400px' }}
        px={{ base: '16px', xl: '0' }}
      >
        <Flex
          flexDirection="column"
          w={{ base: '100%', xl: '870px', '2xl': '1097px' }}
          // w={{ base: '100%', md: '80%', lg: '100%', '2xl': '80%' }}
          m={{ base: '0 auto', xl: '0 30px 0 0', '2xl': '0 48px 0 0' }}
          // mx={{ base: 'auto', '2xl': '0' }}
          my="0"
          py="1rem"
        >
          {/* toggle text */}
          {showOnlyScheduledProductionsVisibility && (
            <Box
              letterSpacing={'0.32px'}
              color="#FEFAF6"
              fontWeight={400}
              lineHeight={{ base: '1.4rem', lg: '1.6rem' }}
              display="flex"
              alignItems="center"
              gap="1rem"
              fontSize={{ base: '.875rem', md: '1rem' }}
              fontFamily="var(--FedraSansStd-book)"
            >
              {/* <Switch
                border="none"
                sx={{
                  '&[aria-checked=true] .chakra-switch__track, &[data-checked] .chakra-switch__track':
                    {
                      bg: '#313336',
                    },
                  '&[aria-checked=true] .chakra-switch__thumb, &[data-checked] .chakra-switch__thumb':
                    {
                      bg: '#010509',
                    },
                  '.chakra-switch__track': {
                    bg: '#313336',
                    // width: '52px', // Adjust track width
                    // height: '32px',
                  },
                  '.chakra-switch__thumb': {
                    bg: '#010509',
                    // width: '20px', // Adjust thumb width
                    // height: '20px',
                  },
                }}
                id="scheduled"
                onChange={e => handleChange(e)}
                isChecked={showOnlyScheduled}
              /> */}
              <Switch
                border="none"
                sx={{
                  // Track (background) color when active or checked
                  '&[aria-checked=true] .chakra-switch__track, &[data-checked] .chakra-switch__track':
                    {
                      bg: '#3F2D21', // Change to your desired color
                    },
                  // Thumb (circle) color when active or checked
                  '&[aria-checked=true] .chakra-switch__thumb, &[data-checked] .chakra-switch__thumb':
                    {
                      bg: '#9F4701', // Change to your desired color circle hover color
                    },
                  // Default track color
                  '.chakra-switch__track': {
                    bg: '#313336',
                  },
                  // Default thumb color
                  '.chakra-switch__thumb': {
                    bg: '#010509',
                  },
                }}
                id="scheduled"
                onChange={e => handleChange(e)}
                isChecked={showOnlyScheduled}
              />
              Show only scheduled productions
            </Box>
          )}
          {extractedObjects &&
            [...extractedObjects]
              ?.slice(0, cardsSlice)
              ?.map(
                ({
                  address,
                  program_url,
                  samskriti,
                  title,
                  filterDate,
                  button_label,
                  amount,
                  date,
                  time,
                  is_online,
                  currency,
                  country,
                  program_id,
                  urlAlias,
                  type,
                  program_category,
                  heroSection,
                  heroImage
                }) => {
                  if (searchParams.get('scheduled') == '1' && type === 'past') {
                    return null;
                  }
                  return (
                    <CalendarTabsCard
                      heroSection={heroSection}
                      heroImage={heroImage}
                      category={program_category}
                      cardCtaLabel={cardCtaLabel}
                      key={nanoid()}
                      address={address}
                      program_url={program_url}
                      samskriti={samskriti}
                      title={title}
                      filterDate={filterDate}
                      button_label={button_label}
                      amount={amount}
                      date={date}
                      time={time}
                      is_online={is_online}
                      currency={currency}
                      country={country}
                      program_id={program_id}
                      urlAlias={urlAlias}
                      type={type}
                      pType="prod"
                    />
                  );
                }
              )}
          {extractedObjects &&
            cardsSlice < totalResults &&
            totalResults !== 0 && (
              <Center>
                <Button
                  variant="ghost"
                  color="#F18128"
                  border="2px solid #F18128"
                  fontFamily="var(--FedraSansStd-book)"
                  _hover={{
                    bg: 'none',
                    color: '#F18128',
                    border: '2px solid #F18128',
                  }}
                  _focus={{
                    bg: 'none',
                    color: '#F18128',
                    border: '2px solid #F18128',
                  }}
                  _active={{
                    bg: 'none',
                    color: '#F18128',
                    border: '2px solid #F18128',
                  }}
                  py="12px"
                  my={'24px'}
                  fontSize="1rem"
                  onClick={() => {
                    setStartRec(startRec + 5);
                    setCardSlice(cardsSlice + 5);
                  }}
                >
                  Load More
                </Button>
              </Center>
            )}
          {isLoading && extractedObjects?.length === 0 && (
            <Center py="2.5rem">
              <Spinner color="#FEFAF6" />
            </Center>
          )}

          <>
            {searchParams.get('scheduled') == '1' &&
            [...extractedObjects].filter(el => el.type == 'past').length ? (
              <Box pt={{ base: '60px', md: '100px' }}>
                <StructuredTextParser
                  textAlign="left"
                  color="#FEFAF6"
                  fontSize={{ base: '34px', md: '52px' }}
                  fontFamily="var(--FedraSerifDisplay)"
                  str={render(message)}
                />
              </Box>
            ) : (
              [...extractedObjects]?.length === 0 && (
                <Box pt={{ base: '60px', md: '100px' }}>
                  <StructuredTextParser
                    textAlign="left"
                    color="#FEFAF6"
                    fontSize={{ base: '34px', md: '52px' }}
                    fontFamily="var(--FedraSerifDisplay)"
                    str={render(message)}
                  />
                </Box>
              )
            )}
          </>
        </Flex>
        {/* white box */}
        <Box
          display="flex"
          flexDirection={{ base: 'column' }}
          gap={{ base: '1.5rem' }}
          mt="4rem"
          width={{ base: '100%', xl: 270, '2xl': 262 }}
        >
          {/* <Box
            padding="2rem"
            bg="#0E1216"
            display="flex"
            maxWidth={{ lg: '326px' }}
            flexDirection="column"
            gap="1.5rem"
            w={{ base: '100%', '2xl': '326px' }}
          >
            <Text
              color={'#FEFAF6'}
              letterSpacing={'0.32px'}
              fontWeight={500}
              fontSize={{ base: '1.125rem', md: '1.25rem' }}
              fontFamily={'var(--FedraSansStd-medium)'}
              lineHeight={{ base: '1.8rem' }}
            >
              Schedule a Production
            </Text>
            <Text
              color={'#F1EDE9'}
              fontWeight={400}
              // color="#F1EDE9"
              lineHeight={{ base: '1.6rem' }}
              letterSpacing={'0.32px'}
              fontFamily={'var(--FedraSansStd-book)'}
              fontSize={{ base: '1rem' }}
            >
              Offer your audience the sublime experience of Indian classical
              arts through productions that are a delight to behold.
            </Text>
            <Button
              bg="#9F47011A"
              fontFamily={'var(--FedraSansStd-medium)'}
              fontSize={{ base: '1rem', md: '1rem' }}
              letterSpacing={'0.32px'}
              lineHeight={{ base: '1.6rem' }}
              paddingY={{ base: '0.75rem' }}
              paddingRight="1rem"
              paddingLeft="1.5rem"
              width="197px"
              height={{ xl: '50px' }}
              border="none"
              display="flex"
              gap="1rem"
              borderRadius="none"
              color="#F18128"
              mb={{ base: '30px', '2xl': '0' }}
              fontWeight={500}
              href="https://preprod-online.sadhguru.org/event-register?event=schedule-a-performance-with-project-samskriti-1075"
              _hover={{
                textDecoration: 'none',
              }}
              target="_blank"
            >
              ENQUIRE NOW <FaArrowRight fontSize="1rem" />
            </Button>
          </Box> */}
          {/* b2 */}
          <Box
            maxWidth={{ lg: '326px' }}
            // maxHeight={{ base: '308px', lg: 'auto', '2xl': '308px' }}
            padding="2rem"
            bg="#0E1216"
            display="flex"
            flexDirection="column"
            w={{ base: '100%', '2xl': '326px' }}
            gap="1.5rem"
          >
            <Text
              color={'#FEFAF6'}
              letterSpacing={'0.32px'}
              fontWeight={500}
              fontSize={{ base: '1.125rem', md: '1.25rem' }}
              fontFamily={'var(--FedraSansStd-medium)'}
              lineHeight={{ base: '1.8rem' }}
            >
              Media Kit
            </Text>
            <Text
              color={'#F1EDE9'}
              fontWeight={400}
              // color="#F1EDE9"o
              lineHeight={{ base: '1.6rem' }}
              letterSpacing={'0.32px'}
              fontFamily={'var(--FedraSansStd-book)'}
              fontSize={{ base: '1rem' }}
            >
              One-stop resource about Project Samskriti, including an overview,
              past press coverage, testimonials, collaterals, schedule, and
              more.
            </Text>
            <Button
              bg="#9F47011A"
              as={Link}
              target="_blank"
              href={`${config.imgPath}/d/46272/1728751121-project-samskriti-slide-deck.pdf`}
              fontFamily={'var(--FedraSansStd-medium)'}
              fontSize={{ base: '1rem', md: '1rem' }}
              letterSpacing={'0.32px'}
              lineHeight={{ base: '1.6rem' }}
              paddingY={{ base: '0.75rem' }}
              paddingRight="1rem"
              paddingLeft="1.5rem"
              width="197px"
              height={{ xl: '50px' }}
              border="none"
              display="flex"
              gap="1rem"
              borderRadius="none"
              color="#F18128"
              fontWeight={500}
              _hover={{
                textDecoration: 'none',
              }}
              // onClick={e => {
              //   download(
              //     'https://static.sadhguru.org/d/46272/1728751121-project-samskriti-slide-deck.pdf'
              //   );
              // }}
            >
              DOWNLOAD <MdOutlineFileDownload fontSize="1.5rem" />
            </Button>
          </Box>
          {/* b2 ends here */}
        </Box>
      </Box>
    </Box>
  );
};

export default ProductionVerticalList;
